import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'search_users_by';
export const useSearchUsersByTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email или имя от 3 символов',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email or name from 3 characters',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email ou nome a partir de 3 caracteres',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Email o nombre desde 3 caracteres',
    },
  },
}) : {}) as Record<string, unknown>;

export const ru = (__LOCALE_RU__ ? (ruRu) : {}) as Record<string, unknown>;
